import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
    BillingPeriod,
    Plan,
    Subscription,
    SubscriptionHistoryItem,
    SubscriptionRedys,
} from './subscriptions.models';

@Injectable({ providedIn: 'root' })
export class SubscriptionsService {
    constructor(private http: HttpClient) {}

    getPlans(): Observable<Plan[]> {
        return this.http.get<Plan[]>(`${environment.apiBaseUrl}/plans`);
    }

    getCurrent(): Observable<Subscription> {
        return this.http.get<Subscription>(`${environment.apiBaseUrl}/subscriptions/me`);
    }

    getMyHistory(limit?: number): Observable<{ ok: boolean; items: SubscriptionHistoryItem[] }> {
        let url = `${environment.apiBaseUrl}/subscriptions/me/history`;
        if (limit != null) url += '?limit=' + limit;
        return this.http.get<{ ok: boolean; items: SubscriptionHistoryItem[] }>(url);
    }

    startCheckout(plan_id: string, period: BillingPeriod) {
        return this.http.post<{ payment: SubscriptionRedys }>(
            `${environment.apiBaseUrl}/subscriptions/start`,
            {
                plan: plan_id,
                period,
            },
        );
    }

    startTree(plan_id: string): Observable<Subscription> {
        return this.http.post<Subscription>(`${environment.apiBaseUrl}/subscriptions/tree`, {
            plan: plan_id,
        });
    }

    cancel(): Observable<void> {
        return this.http.post<void>(`${environment.apiBaseUrl}/subscriptions/cancel`, {});
    }

    submitRedsysForm(payment: SubscriptionRedys) {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = payment.url;
        const add = (n: string, v: string) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = n;
            input.value = v;
            form.appendChild(input);
        };
        add('Ds_SignatureVersion', payment.Ds_SignatureVersion);
        add('Ds_MerchantParameters', payment.Ds_MerchantParameters);
        add('Ds_Signature', payment.Ds_Signature);
        document.body.appendChild(form);
        form.submit();
    }
}
